import React from "react";

const blocksData = [
  {
    id: 1,
    iconSrc: "/images/icon/icon_152.svg",
    title: "Smart Data Insights",
    content:
      "We turn your business data into valuable insights that help you grow.",
    dataAos: "fade-up",
    dataAosDelay: "",
  },
  {
    id: 2,
    iconSrc: "/images/icon/icon_153.svg",
    title: "24/7 Support",
    content: "Our team is here around the clock whenever you need help.",
    dataAos: "fade-up",
    dataAosDelay: "100",
  },
  {
    id: 3,
    iconSrc: "/images/icon/icon_154.svg",
    title: "Powerful AI",
    content:
      "Continuously improving with the latest AI technology to serve your business better.",
    dataAos: "fade-up",
    dataAosDelay: "200",
  },
  {
    id: 4,
    iconSrc: "/images/icon/icon_155.svg",
    title: "Trusted by Businesses",
    content: "Join many businesses who trust us to help them succeed.",
    dataAos: "fade-up",
    dataAosDelay: "300",
  },
];

const Block = () => (
  <>
    {blocksData.map((block) => (
      <div
        key={block.id}
        className="w-1/2 sm:w-1/2 lg:w-1/2 xl:w-1/2 px-3 mb-6"
      >
        <div
          className="flex flex-col h-full bg-dry p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 hover:border-2 hover:border-redlight"
          data-aos={block.dataAos}
          data-aos-delay={block.dataAosDelay}
        >
          <img
            src={block.iconSrc}
            alt={block.title}
            className="w-12 h-12 mb-4"
          />
          <h2 className="text-lg font-semibold text-text mb-2">
            {block.title}
          </h2>
          <p className="text-sm text-textGray flex-grow">{block.content}</p>
        </div>
      </div>
    ))}
  </>
);

const WhyUs = () => {
  return (
    <section className="relative px-4 py-24 lg:py-36 bg-drylight flex flex-col">
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row gap-12">
        {/* Left column */}
        <div
          className="lg:w-1/3 text-center lg:text-left"
          data-aos="fade-right"
        >
          <div className="uppercase text-text text-sm font-semibold mb-3">
            Why us?
          </div>
          <h2 className="text-3xl font-semibold text-white leading-tight">
            Why choose <br />{" "}
            <span className="text-redlight drop-shadow-lg">Lokalai</span> ?
          </h2>
          <p className="text-sm text-text mt-8">
            Helping retail businesses grow smarter with AI-powered solutions.
          </p>
          <img
            src="/images/shape/shape_179.svg"
            alt="shape"
            className="hidden lg:block mt-20"
          />
        </div>

        {/* Right column */}
        <div className="lg:w-2/3">
          <div className="flex flex-wrap -mx-3">
            <Block />
          </div>
        </div>
      </div>

      {/* Decorative shapes */}
      <img
        src="/images/shape/shape_11.svg"
        className="absolute top-0 left-0 w-20 opacity-30"
        alt="shape"
      />
      <img
        src="/images/shape/shape_13.svg"
        className="absolute bottom-0 right-0 w-20 opacity-30"
        alt="shape"
      />
    </section>
  );
};

export default WhyUs;
